import React from "react";
import "../styles/languageModal.scss";

const LanguageModal = ({ handleLanguage }) => {
  return (
    <div className="language_modal_main">
      <div className="container">
        <div className="modal">
          <div className="content">
            <p className="language_text">
              {/* Please select your preferred language */}
              Welcome to this interactive presentation, guided by our AI
              Representative. As you progress through each slide, an AI-powered
              voice will narrate and provide insights, making the experience
              more engaging and informative. Sit back, listen, and enjoy this
              seamless journey where visuals and audio come together
              effortlessly. Click the button below to begin!
            </p>
            <div className="btnGrp">
              {/* <button onClick={() => handleLanguage("HI")}>Hindi</button> */}
              {/* <button onClick={() => handleLanguage("EN")}>English</button> */}
              <button onClick={() => handleLanguage("GO_AHEAD")}>Go Ahead</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
